import '@talentmesh/table/styles.css';
import React, { useState } from 'react';
import { MRT_TableInstance, ShadcnReactTable } from '@talentmesh/table';
import CandidatesTablePaper from '../../../components/CandidatesListPaper';
import useAISearchProgress from '../../api/useAISearchProgress';
import AiSearchListNav from '../AiSearchListNav';
import IdentifiedListToolbar from './IdentifiedListToolbar/IdentifiedListToolbar';
import SearchFailedDialog from './SearchFailedDialog';
import { identifiedListPaginationSizeOptions, useIdentifiedListContext } from './utils/IdentifiedListContext';
import { useIdentifiedTableContext } from './utils/IdentifiedTableContext';
import CandidatesTableContainer from '@/Pages/Candidates/components/CandidatesTableContainer';

const IdentifiedList = () => {
    const table = useIdentifiedTableContext();
    const identifiedList = useIdentifiedListContext();
    const { data } = useAISearchProgress();
    const [rankingRailedDialogOpen, setRankingRailedDialogOpen] = useState(data?.rankingStatus === 'Failed');

    return (
        <CandidatesTablePaper data-cy="identifiedList">
            <IdentifiedListToolbar />
            <CandidatesTableContainer>
                <ShadcnReactTable table={table} />
            </CandidatesTableContainer>
            <AiSearchListNav
                {...identifiedList}
                table={table as MRT_TableInstance<any>}
                paginationSizeOptions={identifiedListPaginationSizeOptions}
            />
            <SearchFailedDialog open={rankingRailedDialogOpen} onClose={() => setRankingRailedDialogOpen(false)} />
        </CandidatesTablePaper>
    );
};

export default IdentifiedList;
